import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faTrash,
  faUserSlash,
} from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { AdminDeleteNftCommentModal } from '@components/Feed/Post/DeletePostModal';
import { DropdownMenuItem } from '@components/basics/Dropdowns/GlobalDropdown';
import { MoreDropdown } from '@components/basics/Dropdowns/MoreDropdown';
import { CommentModalV2 } from '@components/modals/CommentV2';
import { useAuth } from '@context/auth/base';
import { ModalContext, ModalType } from '@context/modal';
import { CommentAuthorFragmentDoc, type FragmentType, getFragment } from '@graphql/reactQuery';

type CommentActionsProps = {
  releaseId: string;
  nftId: string;
  nftCommentId: string;
  commentUserFragment: FragmentType<CommentAuthorFragmentDoc>;
};

export const CommentAction = ({
  releaseId,
  nftCommentId,
  nftId,
  commentUserFragment,
}: CommentActionsProps) => {
  const { openModal } = ModalContext.useContainer();
  const { authUser } = useAuth();
  const commentUser = getFragment(CommentAuthorFragmentDoc, commentUserFragment);

  if (!authUser) {
    return null;
  }

  if (commentUser.id !== authUser.id && !authUser.roles.isAdmin) {
    return null;
  }

  const onEdit = () => {
    openModal(ModalType.COMMENT_MODAL_V2, {
      body: <CommentModalV2 releaseId={releaseId} editNftId={nftId} />,
    });
  };

  const handleAdminDeleteClicked = () => {
    openModal(ModalType.DELETE_POST_COMMENT_CONFIRMATION, {
      body: <AdminDeleteNftCommentModal nftCommentId={nftCommentId} />,
    });
  };

  const handleAdminBlockUserClicked = () => {
    window.open(`${window.location.origin}/admin/moderate/${commentUser.publicAddress}`, '_blank');
  };

  return (
    <div className="flex items-center">
      <MoreDropdown>
        {commentUser.id == authUser.id && (
          <DropdownMenuItem onClick={onEdit}>
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </DropdownMenuItem>
        )}
        {authUser.roles.isAdmin && (
          <>
            <DropdownMenuItem onClick={handleAdminDeleteClicked}>
              <div className="flex items-center font-base text-base-m font-medium text-destructive700">
                <FontAwesomeIcon icon={faTrash} className="mr-1" />
                Delete (Admin)
              </div>
            </DropdownMenuItem>

            <DropdownMenuItem onClick={handleAdminBlockUserClicked}>
              <div className="flex items-center font-base text-base-m font-medium text-destructive700">
                <FontAwesomeIcon icon={faUserSlash} className="mr-1" />
                Block User (Admin)
              </div>
            </DropdownMenuItem>
          </>
        )}
      </MoreDropdown>
    </div>
  );
};
